import React from "react";
import useForm from "components/UI/Form/hooks/useForm";

export default function ResetButton(props) {
  const [onChange, formData] = useForm();
  const values = [];
  const lengthFormData = formData[props.name];
  const onClickHandler = (el) => {
    if (lengthFormData?.length > 0) {
      onChange(
        typeof values == "string"
          ? values?.split(",").filter((val) => val != el?.value)
          : values?.filter((val) => val != el?.value),
        props
      );
    }
  };

  return <button onClick={onClickHandler}>reset</button>;
}
